(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["q4-promo-position"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('q4-promo-position')) {
    customElements.define('q4-promo-position', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        const move = () => {
          const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
          if (!section || !section.parentElement) return;
          const siblings = Array.from(section.parentElement.children);
          const newsletter = siblings.find(node => node.classList.contains('shopify-section--newsletter'));
          if (newsletter) {
            if (section.nextElementSibling !== newsletter) newsletter.before(section);
          } else if (section.parentElement.lastElementChild !== section) {
            section.parentElement.append(section);
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move, { once: true });
        else move();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
